<template>
    <section class="beneficial">

        <div class="load load-200" v-if="!showContent"></div>

        <div class="container" v-if="showContent && errorsGet.dataCompliance != false">
            <div class="box-error">
                <h3 class="title-secondary">
                    {{ getMyLanguage("box-error", "title-error") }}
                </h3>

                <p>{{ getMyLanguage("box-error","msg-error") }}</p>
            </div>
        </div>

        <div class="container" v-if="showContent && !errorsGet.dataCompliance">
            
            <div class="box-beneficial">
                <h2 class="title-secondary">Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange</h2>
                
                <!-- FORM BENEFICIAL -->
                <div>
                    <div class="box-registration">
                        <div class="formBox">
                            <p>(for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnerships that are beneficial owners)</p>
                            <div class="partner">
                                <div>
                                    <h3 class="subtitle">Contracting partner:</h3>
                                    <p>DNE International Sagl</p>
                                    <p>CHE-409.547.100 / Switzerland</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-registration">
                        <div class="formBox">
                            <h3>Pursuant to the anti-money laundering legislation, the contracting partner(s) hereby declare(s) (tick the appropriate box):</h3>

                            <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'beneficial_owner'}">
                                <div class="check"></div>
                                <span>the person(s) listed below is / are holding 25 % or more of the contracting partner’s shares (capital shares or voting rights); or</span>
                            </div>

                            <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'partner'}">
                                <div class="check"></div>
                                <span>if there are no capital shares or voting rights of 25 % or more, that the following person(s) listed below is / are controlling the contracting partner in other ways; or</span>
                            </div>

                            <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'manager'}">
                                <div class="check"></div>
                                <span>in case no person(s) exist(s) who exercise(s) control over the contracting partner in a different capacity, the contracting partner hereby declares that the person(s) listed below is / are the managing director(s).</span>
                            </div>
                        </div>
                    </div>

                     <div class="box-registration">
                        <div class="formBox">
                            <div class="row">
                                <div class="col-12">
                                    <label class="formName">
                                        <span>First name(s), last name(s) / entity:</span>
                                        <div class="form form-disabled">{{dataCompliance.full_name}}</div>
                                    </label>
                                </div>

                                <div class="col-12">
                                    <label class="formAddress last">
                                        <span>Actual address of domicile / registered office (incl. country):</span>
                                        <div class="form form-disabled">{{dataCompliance.full_address}}</div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-registration">
                        <div class="formBox">
                            <h3>Fiduciary holding of assets</h3>
                            <p>Is a third person the beneficial owner of the assets booked under the above relationship?</p>
                            
                            <div class="form form-radio-disabled" :class="{checked: !dataCompliance.fiduciary_holding_assets}">
                                <div class="check"></div>
                                <span>No.</span>
                            </div>

                            <div class="form form-radio-disabled" :class="{checked: dataCompliance.fiduciary_holding_assets}">
                                <div class="check"></div>
                                <span>Yes. &rarr; The relevant information regarding the beneficial owner has to be obtained by filling in a separate form A.</span>
                            </div>
                        </div>
                    </div>

                    <div class="box-registration">
                        <div class="formBox">
                            <h3 class="subtitle">The contracting partner(s) hereby undertake(s) to automatically inform the bank of any changes.</h3>

                            <div class="date-signature">
                                <label>
                                    <span>Date:</span>
                                    <div class="form form-disabled"><span>{{dateTimeFull(dataCompliance.sign_date)}}</span></div>
                                </label>

                                <label>
                                    <span>Signature(s):</span>
                                    
                                    <div class="digital-signature">
                                        <img :src="`data:image/svg+xml;base64,${dataCompliance.signature}`">
                                    </div>

                                    <span class="form formSignature" v-html="dataCompliance.partners.filter(partner => partner.account_id == dataCompliance.company_member_account_id)[0].full_name"></span>
                                </label>
                            </div>
                            
                            <p class="alert">It is a criminal offence to deliberately provide false information on this form (Article 251 of the Swiss Criminal Code, document forgery).</p>
                        </div>
                    </div>
                </div>

                <div class="bt-registration">
                    <div @click="generateReport()" class="download-pdf">PDF</div>
                </div>


                <!-- PRINT PDF -->
                <vue3-simple-html2pdf
                    ref="vue3SimpleHtml2pdf"
                    :options="pdfOptions"
                    :filename="exportFilename"
                    >

                    <div class="print" id="printArea">

                        <h2 class="title-secondary">Establishing of the controlling person of operating legal entities and partnerships both not quoted on the stock exchange</h2>

                        <div class="table">
                            <tr>
                                <td colspan="2">
                                    <p>(for operating legal entities and partnerships that are contracting partner as well as analogously for operating legal entities and partnerships that are beneficial owners)</p>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <h3 class="subtitle">Contracting partner:</h3>
                                    <p>DNE International Sagl</p>
                                    <p>CHE-409.547.100 / Switzerland</p>
                                
                                    <div class="area"></div>

                                    <h5>Pursuant to the anti-money laundering legislation, the contracting partner(s) hereby declare(s) (tick the appropriate box):</h5>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div class="form-print">
                                        <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'beneficial_owner'}">
                                            <div class="check"></div>
                                            <span>the person(s) listed below is / are holding 25 % or more of the contracting partner’s shares (capital shares or voting rights); or</span>
                                        </div>

                                        <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'partner'}">
                                            <div class="check"></div>
                                            <span>if there are no capital shares or voting rights of 25 % or more, that the following person(s) listed below is / are controlling the contracting partner in other ways; or</span>
                                        </div>

                                        <div class="form form-radio-disabled" :class="{checked: dataCompliance.company_member_type == 'manager'}">
                                            <div class="check"></div>
                                            <span>in case no person(s) exist(s) who exercise(s) control over the contracting partner in a different capacity, the contracting partner hereby declares that the person(s) listed below is / are the managing director(s).</span>
                                        </div>
                                    </div>
                                
                                    <div class="area"></div>

                                    <div class="form-print">
                                        <span>First name(s), last name(s) / entity:</span>
                                        <div class="form form-disabled">{{dataCompliance.full_name}}</div>
                                    
                                        <span>Actual address of domicile / registered office (incl. country):</span>
                                        <div class="form form-disabled full">{{dataCompliance.full_address}}</div>
                                    </div>
                                
                                    <div class="area"></div>

                                    <h5>Fiduciary holding of assets</h5>
                                    <p>Is a third person the beneficial owner of the assets booked under the above relationship?</p>
                                    
                                    <div class="form-print">
                                        <div class="form form-radio-disabled" :class="{checked: !dataCompliance.fiduciary_holding_assets}">
                                            <div class="check"></div>
                                            <span>No.</span>
                                        </div>

                                        <div class="form form-radio-disabled" :class="{checked: dataCompliance.fiduciary_holding_assets}">
                                            <div class="check"></div>
                                            <span>Yes. &rarr; The relevant information regarding the beneficial owner has to be obtained by filling in a separate form A.</span>
                                        </div>
                                    </div>
                                
                                    <div class="area"></div>

                                    <h3 class="subtitle">The contracting partner(s) hereby undertake(s) to automatically inform the bank of any changes.</h3>
                                </td>
                            </tr>
                            <tr>
                                <td>                                    
                                    <div class="date-signature-print">
                                        <span>Date:</span>
                                        <div class="form form-disabled">{{dateTimeFull(dataCompliance.sign_date)}}</div>
                                    </div>
                                </td>
                                
                                <td>
                                    <div class="digital-signature-print">
                                        <div>
                                            <span>Signature(s):</span>

                                            <div class="digital-signature">
                                                <img :src="`data:image/svg+xml;base64,${dataCompliance.signature}`">
                                            </div>

                                            <span class="form formSignature" v-html="dataCompliance.partners.filter(partner => partner.account_id == dataCompliance.company_member_account_id)[0].full_name"></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <p class="alert">
                                        It is a criminal offence to deliberately provide false information on this form (Article 251 of the Swiss Criminal Code, document forgery).
                                    </p>
                                </td>
                            </tr>
                        </div>
                    </div>
                </vue3-simple-html2pdf>
            </div>
        </div>
    </section>
</template>


<script>
    import apiBackoffice from '@/config/apiBackoffice.js'
    import moment from 'moment';

    const html2pdf = require('html2pdf.js')

    export default {
        props: {
            index: {
                type: Number,
                default: 1,
            },
            filename: {
                type: String,
                default: '',
            },
            options:{
                default: {
                    margin: 15,
                    image: {
                        type: 'jpeg',
                        quality: 1,
                    },
                    html2canvas: { scale: 3 },
                }
            }
        },

        data(){
            return{
                showContent: false,
                flagSelected: "pt",

                dataCompliance: {},

                // dataCountry: [],

                errorsGet: {
                    dataCompliance: false
                }
            }
        },

        async mounted(){
            await apiBackoffice.get(`/api/v2/platform/compliance/ubo/company/${this.$route.params.accountId}`)
            .then(response => {
                this.dataCompliance = response.data
                this.dataCompliance.signature = "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"
                console.log(this.dataCompliance)

                this.signatureName()

                setTimeout(() => {
                    this.showContent = true
                }, 500);
            })
            .catch(error => {
                console.log(error)
                this.errorsGet.dataCompliance = true
            })
        },

        methods: {
            dateTime(value) {
                // const format = this.flagSelected === 'en' ? 'YY/MM/DD' : 'DD/MM/YY';
                const format = 'DD/MM/YYYY';
                return moment(value).format(format);
            },

            dateTimeFull(value) {
                const format = 'll'
                return moment.utc(value).locale(format).format('ll');
            },

            signatureName(){
                const nameSignature = this.dataCompliance.partners.filter(partner => partner.account_id == this.dataCompliance.company_member_account_id)[0].full_name;
                const nameSignatureLowercase = nameSignature.toLowerCase();
                const words = nameSignatureLowercase.split(' ');
                const wordsUppercase = words.map(words => words.charAt(0).toUpperCase() + words.slice(1));
                const nameSignatureFinished = wordsUppercase.join(' ');
                this.dataCompliance.partners.filter(partner => partner.account_id == this.dataCompliance.company_member_account_id)[0].full_name = nameSignatureFinished;
            },

            generateReport () {
                document.getElementById("printArea").style.display = "block"

                setTimeout(() => {
                    document.getElementById("printArea").style.display = "none"
                }, 50);
                
                const el = document.getElementById(`Vue3SimpleHtml2pdf${this.index}`)
                if (!el) {
                    return
                }
                html2pdf().from(el).set(this.options).save("Compliance - " + this.dataCompliance.full_name)
            }
        },

        // watch: {
        //     '$store.state.allCountries': {
        //         immediate: true,
        //         handler() {
        //             this.dataCountry = this.$store.state.allCountries

        //             setTimeout(() => {
        //                 this.showContent = true
        //             }, 1500);
        //         }
        //     }
        // }
    }
</script>

<style src="./custom-ubo.scss" lang="scss" scoped />